/**
 * @return  ['scheduled-reports']
 * */
// eslint-disable-next-line import/prefer-default-export
export const scheduledReportsKey = () => ["scheduled-reports"];
